import { useState, useEffect, useCallback, useRef } from 'react';
import * as assistantEureka from '../services/assistantEureka';

export const useAssistant = () => {
  const [kpis, setKpis] = useState(null);
  const [informe, setInforme] = useState('');
  const [recomendaciones, setRecomendaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [chatHistory, setChatHistory] = useState([]);
  const isMounted = useRef(true);

  const actualizarDatos = useCallback(() => {
    if (!isMounted.current) return;

    setLoading(true);

    setTimeout(() => {
      if (!isMounted.current) return;

      try {
        const nuevosKpis = assistantEureka.calcularKPIs();
        const nuevoInforme = assistantEureka.generarInformeNarrativo();
        const nuevasRecomendaciones = assistantEureka.generarRecomendaciones();

        setKpis(nuevosKpis);
        setInforme(nuevoInforme);
        setRecomendaciones(nuevasRecomendaciones);
      } catch (error) {
        console.error('Error al actualizar datos del asistente:', error);
      } finally {
        setLoading(false);
      }
    }, 100);
  }, []);

  const enviarPregunta = useCallback((pregunta) => {
    if (!pregunta.trim()) return;

    const respuesta = assistantEureka.procesarPreguntaAsistente(pregunta);

    setChatHistory(prev => [
      ...prev,
      {
        id: Date.now(),
        tipo: 'usuario',
        mensaje: pregunta,
        timestamp: new Date()
      },
      {
        id: Date.now() + 1,
        tipo: 'asistente',
        mensaje: respuesta,
        timestamp: new Date()
      }
    ]);

    return respuesta;
  }, []);

  const limpiarChat = useCallback(() => {
    setChatHistory([]);
  }, []);

  const ejecutarWorkflow = useCallback((nombreWorkflow) => {
    return `Ejecutando workflow: ${nombreWorkflow}`;
  }, []);

  const obtenerResumenMensual = useCallback(() => {
    return assistantEureka.generarResumenMensual();
  }, []);

  const obtenerEstadisticasRapidas = useCallback(() => {
    return assistantEureka.obtenerEstadisticasRapidas();
  }, []);

  useEffect(() => {
    isMounted.current = true;
    actualizarDatos();

    return () => {
      isMounted.current = false;
    };
  }, [actualizarDatos]);

  return {
    kpis,
    informe,
    recomendaciones,
    loading,
    chatHistory,
    actualizarDatos,
    enviarPregunta,
    limpiarChat,
    ejecutarWorkflow,
    obtenerResumenMensual,
    obtenerEstadisticasRapidas
  };
};
